// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createStoreReturnRequest = (client) => ({
    /**
     * `POST /store/return-request`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreCreateOrderReturnRequest
     * @source packages/modules/requests/src/api/store/return-request/route.ts
     */
    create: (body, query, headers) => client.fetch("/store/return-request", { method: "POST", body, query, headers }),
    /**
     * `GET /store/return-request`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreListOrderReturnRequests
     * @source packages/modules/requests/src/api/store/return-request/route.ts
     */
    list: (query, headers) => client.fetch("/store/return-request", { method: "GET", query, headers }),
    /**
     * `GET /store/return-request/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreGetOrderReturnRequestById
     * @source packages/modules/requests/src/api/store/return-request/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/store/return-request/:id", [id]), { method: "GET", query, headers }),
});
//# sourceMappingURL=return-request.js.map